import { render, staticRenderFns } from "./TrailersForm.vue?vue&type=template&id=5bf6a471&scoped=true"
import script from "./TrailersForm.vue?vue&type=script&lang=js"
export * from "./TrailersForm.vue?vue&type=script&lang=js"
import style0 from "./TrailersForm.vue?vue&type=style&index=0&id=5bf6a471&prod&lang=scss"
import style1 from "./TrailersForm.vue?vue&type=style&index=1&id=5bf6a471&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf6a471",
  null
  
)

export default component.exports